import React from "react";
import PropTypes from "prop-types";
import Button from "../../../common/Button";
import NextIcon from "@material-ui/icons/NavigateNext";
import PrevIcon from "@material-ui/icons/NavigateBefore";

import styles from "./neighboring.module.scss";

function Neighboring({items: {previous, next}}) {
  return (
    <div className={styles.root}>
      <div className={styles.left}>
        {previous && previous.path && (
          <Button href={previous.path}>
            <PrevIcon />
            {previous.name}
          </Button>
        )}
      </div>
      <div className={styles.right}>
        {next && next.path && (
          <Button href={next.path}>
            {next.name}
            <NextIcon />
          </Button>
        )}
      </div>
    </div>
  );
}

Neighboring.propTypes = {
  items: PropTypes.shape({
    previous: PropTypes.shape({
      path: PropTypes.string,
      name: PropTypes.string
    }),
    next: PropTypes.shape({
      path: PropTypes.string,
      name: PropTypes.string
    })
  })
};

export default Neighboring;
